import { toggleBlockType, toggleInlineStyle } from "../utils";

import EditorInlineTooltip from "./EditorInlineTooltip";
import PropTypes from "prop-types";
import React from "react";

export default function EditorInlineToolbar({ position, visible, innerRef, editorState, onChange, children }) {
  return (
    <EditorInlineTooltip position={position} visible={visible} innerRef={innerRef}>
      <div onMouseDown={(event) => event.preventDefault()} css={wrapperStyle}>
        {children({
          editorState,
          toggleInlineStyle: toggleInlineStyle(editorState, onChange),
          toggleBlockType: toggleBlockType(editorState, onChange),
        })}
      </div>
    </EditorInlineTooltip>
  );
}

EditorInlineToolbar.propTypes = {
  innerRef: PropTypes.func.isRequired,
  position: PropTypes.shape({
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
  }).isRequired,
  visible: PropTypes.bool.isRequired,
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
};

const wrapperStyle = {
  display: "flex",
  flexDirection: "row",
};
